//引入路由模块
import Vue from 'vue'
import Router from 'vue-router'
import storage from 'good-storage'
import store from '../vuex/index'
import ut from '../assets/util'
import App from '../App'
//使用路由模块
Vue.use(Router)

const router = new Router({
    routes: [{
        path: '/',
        name: 'index',
        component: () => import('@/pages/index'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/',
        name: 'test',
        component: () => import('@/pages/test'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login'),
    },
    {
        path: '/class',
        name: 'class',
        meta: {
            requireAuth: true,
            isAdmin: true
        },
        component: () => import('@/pages/class'),
    },
    {
        path: '/user',
        name: 'user',
        meta: {
            requireAuth: true,
            isAdmin: true
        },
        component: () => import('@/pages/user'),
    }
    ]
})

router.beforeEach(async (to, from, next) => {
    let token = storage.get("token")
    if (!store.state.token) store.state.token = token
    if (to.meta.requireAuth && !token) { // 判断该路由是否需要登录权限
        next('/login')
        return
    }
    let userInfo = store.state.userInfo
    if (to.meta.requireAuth) {//需要认证
        if (token) {
            if (!userInfo) {//没有用户信息
                try {
                    userInfo = await ut.req({
                        url: `api/user/login`
                    })
                    store.commit('userInfoSet', userInfo)
                } catch (err) {
                    storage.clear()
                    next('/login')
                    return
                }
            }

            if (to.meta.isAdmin && !userInfo.isAdmin) {
                next({ name: 'index' })
                return
            }
        } else {
            next('/login')
            return
        }
    }
    next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js